import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToasterService } from '../shared/services/toaster/toaster.service';
import { ILearningPlayerRank } from '../talent-litmus-core/learning-player-core/learning-player-core.service';
import { ValuesGamePlayerCoreService } from '../talent-litmus-core/values-game-player-core';

@Injectable()
export class CocaColaService {
  private _scientificRigourPlayers$ = new BehaviorSubject<
    ILearningPlayerRank[]
  >([]);
  get scientificRigourPlayers$(): Observable<ILearningPlayerRank[]> {
    return this._scientificRigourPlayers$.asObservable();
  }

  constructor(
    private _valuesGamePlayerService: ValuesGamePlayerCoreService,
    private _toast: ToasterService,
  ) {}

  public fetchPlayersData(): void {
    this._valuesGamePlayerService
      .getValuesPlayerLeaderboard(
        '63286676c55cdc001477d657',
        '63288535c55cdc001477d7c8',
      )
      .pipe(
        catchError((err) => {
          this._toast.showError(err.error.message);
          return of([]);
        }),
      )
      .subscribe((players: any[]) => {
        console.log(players);
        const filteredPlayers: any[] = [];
        let rank = 1;
        players.forEach((player) => {
          const obj = {};

          obj['name'] =
            (player['firstName'] || '') +
            ' ' +
            (player['lastName'] || '') +
            (player['lastname'] || '');
          obj['learnerId'] = player.learnerId;

          obj['totalScore'] = player.totolScore;
          obj['Innovation'] = player.valueScores['Innovation'];
          obj['NetRevenue'] = player.valueScores['Net Revenue'];
          obj['StakeholderEngagement'] =
            player.valueScores['Stakeholder Engagement'];
          obj['rank'] = rank;
          rank++;
          filteredPlayers.push(obj);
        });

        this._scientificRigourPlayers$.next(filteredPlayers);
      });
  }
}
